import { FileButton, Flex, Group, Input } from '@mantine/core';
import { Button, Text } from '@repo/foundations';
import type { ReactNode } from 'react';

export function UploadWrapper({
	children,
	label,
	onClick,
	disabled = false,
}: {
	children: ReactNode;
	label: string;
	onClick: (file: File) => void;
	disabled?: boolean;
}) {
	return (
		<Input.Wrapper
			label={
				<Flex gap="3xs">
					<Text weight="semibold" size="sm">
						{label}
					</Text>
					<Text size="sm" color="text/secondary/default">
						(Optional)
					</Text>
				</Flex>
			}
		>
			<Group spacing="sm">
				{children}

				<FileButton
					onChange={onClick}
					accept="image/png,image/jpeg"
					disabled={disabled}
				>
					{(props) => (
						<Button size="sm" leftIconName="upload" {...props}>
							Upload
						</Button>
					)}
				</FileButton>
			</Group>
		</Input.Wrapper>
	);
}
